import HierarchyKPICurrencyDetails from './HierarchyKPICurrencyDetails'
export default HierarchyKPICurrencyDetails
